import { FileIcon } from "@msuite/ui/file-upload";
import { useLoading } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { responseHandler } from "@msuite/ui/utils";
import type { RiskAssessmentListItem } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface AttendanceRiskAssessmentItemProps {
	item: RiskAssessmentListItem;
}

export function AttendanceRiskAssessmentItem({ item }: AttendanceRiskAssessmentItemProps) {
	/** Hooks */
	const loader = useLoading();

	/** Functions */
	async function handleOnOpen() {
		loader.start();
		const response = await client.files[":fileId"].$get({ param: { fileId: item.file.id } });
		const data = await responseHandler(response);
		if (data.signedUrl) window.open(data.signedUrl, "_blank");
		loader.stop();
	}

	/** Render */
	return (
		<button
			type="button"
			onClick={handleOnOpen}
			disabled={loader.isLoading}
			className="card h-stack justify-between"
		>
			<div className="h-stack">
				<FileIcon
					fileType={item.file.contentType}
					size={16}
				/>
				<span className="flex-1 truncate text-sm">{item.file.fileName}</span>
			</div>
			<Icon
				name="ExternalLink"
				size={14}
			/>
		</button>
	);
}
